const compare = (first, second) => {
  if (first.stats.questions > second.stats.questions) {
    return -1;
  }
  if (first.stats.questions < second.stats.questions) {
    return 1;
  }
  return 0;
};

export const processTags = (tags) => {
  let followedTags = [];
  const followedTagsNames = [];
  const notFollowedTags = [];
  const sortedTags = [];
  const filteredTags = { ...tags };

  followedTags = Object.keys(tags).reduce((following, key) => {
    const followingTags = [...following];
    const currentTag = tags[key];
    sortedTags.push(currentTag);
    if (currentTag.following) {
      followingTags.push(currentTag);
      followedTagsNames.push(currentTag.name);
      delete filteredTags[currentTag.id];
      return followingTags;
    }
    notFollowedTags.push(currentTag);
    return following;
  }, followedTags);

  return {
    followed: followedTags.sort(compare),
    followedNames: followedTagsNames,
    notFollowed: notFollowedTags.sort(compare),
    sorted: sortedTags.sort(compare),
    filtered: filteredTags
  };
};

/**
 * This util returns
 *
 * followed: Array<FollowedTags> order by name
 * followedNames: Array<FollowedTag.name>
 * notFollowed: Array<NotFollowedTags> order by name
 * sorted: Array<AllTags> order by name
 * filtered: Object{NotFollowedTags}
 *
 */
